var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(row,index){return _c('div',{key:index,staticClass:"row"},[_vm._l((row.columns),function(col,ind){return [_c(col.helper,{key:ind,tag:"componet",class:col.class})]})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }